<template>
  <v-col
    cols="12"
    md="8"
    offset-md="2"
    class="pa-3"
    v-shortkey="{
      up: ['arrowup'],
      down: ['arrowdown'],
      enter: ['enter'],
      openall: ['o'],
      escape: ['esc'],
      search: ['/'],
      edit: ['e'],
      add_url: ['a'],
      add_folder: ['f'],
      lock_toggle: ['l'],
    }"
    @shortkey="globalKeyPress"
  >
    <v-text-field
      outlined
      dense
      hide-details
      clearable
      prepend-inner-icon="mdi-magnify"
      label="Search (/)"
      v-model="search"
      ref="main_search"
      @keyup.enter="$refs.main_search.blur()"
      @keyup.esc="$refs.main_search.blur()"
      @keyup.down="searchKeyupDown"
    />
    <EncryptionAlert class="my-5" v-if="$store.state.fullscreen.encryption_alert" />
    <SearchResults v-show="if_search" ref="search_results" />
    <TopButtons v-show="!if_search" ref="topbuttons" />
    <List ref="list" v-show="!if_search" class="mt-2" />
    <ModalURL />
    <ModalFolder />
    <ModalMove />
    <ModalOpenAll />
    <ModalLock ref="modal_lock" />
  </v-col>
</template>

<script>
import * as fb from "../firebase";

import TopButtons from "../components/TopButtons";
import SearchResults from "../components/SearchResults";
import List from "../components/List";
import ModalURL from "../components/ModalURL";
import ModalFolder from "../components/ModalFolder";
import ModalMove from "../components/ModalMove";
import ModalOpenAll from "../components/ModalOpenAll";
import ModalLock from "../components/ModalLock";
import EncryptionAlert from "../components/EncryptionAlert";

// import { VueNestable, VueNestableHandle } from "vue-nestable";

const { v4: uuidv4 } = require("uuid");

export default {
  name: "bookmarks",
  metaInfo() {
    return this.generateMeta({ name: "bookmarks", path: this.$route.path });
  },
  components: {
    TopButtons,
    SearchResults,
    ModalURL,
    ModalFolder,
    ModalMove,
    ModalOpenAll,
    ModalLock,
    // VueNestable,
    // VueNestableHandle,
    List,
    EncryptionAlert,
  },
  data() {
    return {
      searchProcessId: null,
    };
  },
  watch: {
    search(value) {
      // reset active item
      this.$store.commit("updateStateSearch", { active_index: -1 });
      // reset ongoing search if any
      clearInterval(this.searchProcessId);
      // init search with debounce
      if (value && value.length != 0) {
        this.searchProcessId = setTimeout(() => {
          this.$store.dispatch("search");
        }, 200);
      }
    },
    active_index(value) {
      console.log("active_index change");
      if (value < 0) return;

      let active_item = null;
      if (this.if_search) {
        active_item = this.$store.state.search.search_results[value];
      } else {
        active_item = this.$store.getters.active_list[value];
      }
      console.log(active_item.label);
      this.scrollToIdIfNotSeen(active_item.id);
    },
  },
  mounted() {
    // console.log(this.$route, "route");
    console.log("mounted");
    // debugger;
    this.$store.dispatch("changeActiveParentFromID", decodeURIComponent(this.$route.params.id));

    // empty search
    this.$store.commit("updateStateSearch", { search: null });

    // check bookmarklet url
    if (this.$route.query.bookmarkleturl) {
      this.$store.dispatch("clickAddURL");
      this.$store.commit("updateStateFormURL", {
        url: this.$route.query.bookmarkleturl,
      });
    }
  },
  methods: {
    submitURL() {
      console.log("submitURL");
      this.$store.commit("addBookmark", {
        index: 0,
        url: this.url,
      });
    },
    globalKeyPress(event) {
      console.log(event, "globalKeyPress");

      switch (event.srcKey) {
        case "up":
          this.$store.dispatch("activeIndexDecrement");
          break;
        case "down":
          this.$store.dispatch("activeIndexIncrement");
          break;
        case "enter":
          this.$store.dispatch("activeIndexSubmit");
          break;
        case "openall":
          this.$store.dispatch("openAll", { checkCount: true });
          break;
        case "escape":
          if (this.$store.getters.any_modal_open) {
            this.$store.dispatch("close_all_modals");
          } else if (this.$store.state.edit_mode) {
            this.$store.commit("updateStateVariable", { edit_mode: false });
          } else if (this.$store.getters.if_search) {
            this.$store.commit("updateStateSearch", { search: null });
          }
          break;
        case "search":
          this.$refs.main_search.focus();
          break;
        case "edit":
          this.$store.commit("updateStateVariable", {
            edit_mode: !this.$store.state.edit_mode,
          });
          this.$store.commit("selectAll", false);
          break;
        case "add_url":
          this.$store.dispatch("clickAddURL");
          break;
        case "add_folder":
          this.$store.dispatch("clickAddFolder");
          break;
        case "lock_toggle":
          if (!this.$store.state.lock.unlocked) {
            this.$store.commit("updateStateLock", { modal: true });
          } else {
            this.$store.dispatch("lock");
          }
          break;
      }

      return true;
    },
    searchKeyupDown() {
      this.$refs.main_search.blur();
      this.$store.dispatch("activeIndexIncrement");
    },
    scrollToIdIfNotSeen(id) {
      let $el = document.getElementById(id);
      let ifVisible = this.isInViewport($el);
      console.log(ifVisible, "item visible?");
      if (!ifVisible) {
        this.$vuetify.goTo($el, {
          duration: 500,
          offset: (window.innerHeight || document.documentElement.clientHeight) / 2,
          easing: "easeInOutCubic",
        });
      }
    },
    isInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
  },
  computed: {
    search: {
      get() {
        return this.$store.state.search.search;
      },
      set(value) {
        this.$store.commit("updateStateSearch", { search: value });
      },
    },
    if_search() {
      return this.$store.getters.if_search;
    },
    active_index() {
      return this.$store.state.search.active_index;
    },
  },
};
</script>
